// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import MeasurementReading from '@deere/cps-it.warranty-model-factory/lib/measurement-reading';
import Modal from '../../shared/state/modal';
import Product from '@deere/cps-it.warranty-model-factory/lib/product';
import ProductInfoPanel from '../../shared/components/product-info-panel/product-info-panel';

const NewTransferHeader = props =>
    <section className='new-transfer-header'>
        <h2>
            <FormattedMessage id='CHANGE_RESPONSIBLE_DEALER'/>
        </h2>
        <ProductInfoPanel
            changeModalVisibility={props.changeModalVisibility}
            isAmountOfUseModalOpen={props.isAmountOfUseModalOpen}
            measurementReadings={props.measurementReadings}
            onAmountOfUseModalClose={props.onAmountOfUseModalClose}
            onAmountOfUseModalOpen={props.onAmountOfUseModalOpen}
            product={props.product}
            productStatusChangeModal={props.productStatusChangeModal}
            updateStatus={props.updateStatus}
        />
    </section>;

NewTransferHeader.displayName = 'NewTransferHeader';
NewTransferHeader.propTypes = {
    changeModalVisibility: PropTypes.func.isRequired,
    isAmountOfUseModalOpen: PropTypes.bool.isRequired,
    measurementReadings: PropTypes.arrayOf(PropTypes.instanceOf(MeasurementReading)).isRequired,
    onAmountOfUseModalClose: PropTypes.func.isRequired,
    onAmountOfUseModalOpen: PropTypes.func.isRequired,
    product: PropTypes.instanceOf(Product).isRequired,
    productStatusChangeModal: PropTypes.instanceOf(Modal).isRequired,
    updateStatus: PropTypes.func.isRequired
};

export default NewTransferHeader;



// WEBPACK FOOTER //
// ./src/product/new-transfer/components/new-transfer-header.js